import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { recuperaPassword } from '../../actions/auth';

const RecuperaPassword = ({ alert, recuperaPassword, isAuthenticated }) => {

    useEffect(() => {
        const size = alert.length;
        if(size>0){
            if(alert[size-1].alertType === "success"){
                setSuccessForm(true)
            }
        }
    }, [alert]);

    const [successForm, setSuccessForm] = useState(false)


    const [formData, setFormData] = useState({
        codicefiscale: ''
    });


    const { codicefiscale } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = async e => {
        e.preventDefault();
        recuperaPassword({ codicefiscale });
    };

    if (isAuthenticated) {
        return <Redirect to="/" />
    }


    return (
        <div id="registrazione-condomino" class="accedi wf-section">
            <div class="container flex-center">
                <div class="form-wrap"><img src="/assets/media/logo-amministrazioni2t.png" loading="lazy" alt="" class="logo"/>
                    <div class="form-block w-form">
                        {successForm ?
                        <div class="container flex-center">
                        <h3 class="no-margin">Controlla la tua email</h3>
                        <p class="m10 center">Abbiamo inviato una email al tuo indirizzo.</p>
                        </div>
                        :
                        <form id="wf-form-login-form" name="wf-form-login-form" data-name="login form" class="form" onSubmit={e => onSubmit(e)}>
                            <h3 id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d03-40413f47" class="no-margin">Inserisci il tuo codice fiscale per recuperare la password</h3>
                            <div id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d0d-40413f47" class="column">
                                <label for="codicefiscale" class="form-label">Codice fiscale</label>
                                <input type="text" class="input-field company w-input" maxlength="256" name="codicefiscale" data-name="codicefiscale" placeholder="Codice Fiscale" id="codicefiscale" required="true" value={codicefiscale} onChange={e => onChange(e)}/>
                            </div>
                            <input type="submit" value="Recupera password" data-wait="Un attimo..." id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d2b-40413f47" class="submit-button w-button"/>
                        </form>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

RecuperaPassword.propTypes = {
    recuperaPassword: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    alert: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    alert: state.alert
});

export default connect(mapStateToProps, { recuperaPassword })(RecuperaPassword);